import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CadeReportAssessment from './CadeReportAssessment';
import CadeComponentHeader from './CadeComponentHeader';
import CadeComponentDoodle from './CadeComponentDoodle';
import CadeReportPerson from './CadeReportPerson';
import authService from '../../services/AuthService';
import { getCadeModeForName } from '../../helpers/CadeComponentHelpers';
import api, { apiResponseHandler, apiErrorHandler } from '../../services/AxiosService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';

import './CadeInput.css';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class CadeReportAssessmentComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assessmentId: props.assessmentId,
            providerId: props.providerId,
            isAssessmentComplete: false,
            cadeMode: props.cadeMode,
            cadeDomain: null,
            domainDisplayName: props.domainDisplayName,
            clinicianName: props.clinicianFirstName + " " + props.clinicianLastName,
            clinicianDegrees: props.clinicianDegrees,
            reasonForReferral: null,
            testDate: null,
            reportDate: null,
            patientAgeWhenTested: null,
            testsAdministered: null,
            testResults: null,
            diagnosticImpressions: null,
            summary: null,
            nextStep1: null,
            nextStep2: null,
            nextStep3: null,
            nextStep4: null,
            nextStep5: null,
            readonly: false,
            includeAssessmentRadarChart: true,
            includeAssessmentBarChart: true,
            accordionActiveKey: -1,
            cgName: null,
            r1Name: null,
            r2Name: null
        }
        this.assessmentReportKey = 1;
    }

    generateAssessmentReportKey = () => {
        return new Date().getTime();
    }

    saveHandler = ( accordionActiveKey, assessmentId, clinicianName, clinicianDegrees, patientAgeWhenTested, testDate, testsAdministered, reportDate, reasonForReferral, testResults, diagnosticImpressions, summary, nextStep1, nextStep2, nextStep3, nextStep4, nextStep5, includeAssessmentRadarChart, includeAssessmentBarChart) => {

        let reportModel = {
            assessmentId: assessmentId,
            isAssessmentComplete: false,    // doesn't matter
            domainName: null,
            authenticatedUserId: authService.authenticatedUserId,
            clinicianName: clinicianName,
            clinicianDegrees: clinicianDegrees,
            patientAgeWhenTested: patientAgeWhenTested,
            testDate: testDate,
            testsAdministered: testsAdministered,
            reportDate: reportDate,
            reasonForReferral: reasonForReferral,
            testResults: testResults,
            diagnosticImpressions: diagnosticImpressions,
            summary: (isNullOrEmpty(summary)) ? null : btoa(encodeURIComponent(summary)),     // base-64 encode these because, for some reason, the production server (production only) will not accept http:// or https:// in any string
            nextStep1: (isNullOrEmpty(nextStep1)) ? null : btoa(encodeURIComponent(nextStep1)),
            nextStep2: (isNullOrEmpty(nextStep2)) ? null : btoa(encodeURIComponent(nextStep2)),
            nextStep3: (isNullOrEmpty(nextStep3)) ? null : btoa(encodeURIComponent(nextStep3)),
            nextStep4: (isNullOrEmpty(nextStep4)) ? null : btoa(encodeURIComponent(nextStep4)),
            nextStep5: (isNullOrEmpty(nextStep5)) ? null : btoa(encodeURIComponent(nextStep5)),
            includeAssessmentRadarChart: includeAssessmentRadarChart,
            includeAssessmentBarChart: includeAssessmentBarChart
        }

        let url = "/assessment/" + this.state.assessmentId + "/reportconfig";
        api.post(url, reportModel,
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    this.assessmentReportKey = this.generateAssessmentReportKey();
                    this.setState({
                        clinicianName: clinicianName,
                        clinicianDegrees: clinicianDegrees,
                        patientAgeWhenTested: patientAgeWhenTested,
                        testDate: testDate,
                        testsAdministered: testsAdministered,
                        reportDate: reportDate,
                        reasonForReferral: reasonForReferral,
                        testResults: testResults,
                        diagnosticImpressions: diagnosticImpressions,
                        summary: summary,
                        nextStep1: nextStep1,
                        nextStep2: nextStep2,
                        nextStep3: nextStep3,
                        nextStep4: nextStep4,
                        nextStep5: nextStep5,
                        includeAssessmentRadarChart: includeAssessmentRadarChart,
                        includeAssessmentBarChart: includeAssessmentBarChart,
                        accordionActiveKey: accordionActiveKey
                    });
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                };
            })
            .catch((error) => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));
            });
    }

    componentDidMount = () => {
        let url = "assessment/" + this.state.assessmentId + "/reportconfig/Understanding/uid/" + authService.authenticatedUserId + "/ut/" + this.props.cadeModeFor;  // Domain name doesn't matter for this call so we use Understanding.  Just want the base assessment report config
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                this.assessmentReportKey = this.generateAssessmentReportKey();
                this.setState({
                    assessmentId: response.data.assessmentId,
                    isAssessmentComplete: response.data.isAssessmentComplete,
                    authenticatedUserId: response.data.authenticatedUserId,
                    clinicianName: response.data.clinicianName,
                    clinicianDegrees: response.data.clinicianDegrees,
                    reasonForReferral: response.data.reasonForReferral,
                    testDate: response.data.testDate,
                    reportDate: response.data.reportDate,
                    patientAgeWhenTested: response.data.patientAgeWhenTested,
                    testsAdministered: response.data.testsAdministered,
                    testResults: response.data.testResults,
                    diagnosticImpressions: response.data.diagnosticImpressions,
                    summary: response.data.summary,
                    nextStep1: response.data.nextStep1,
                    nextStep2: response.data.nextStep2,
                    nextStep3: response.data.nextStep3,
                    nextStep4: response.data.nextStep4,
                    nextStep5: response.data.nextStep5,
                    readonly: response.data.authenticatedUserReadonly,
                    includeAssessmentRadarChart: response.data.includeAssessmentRadarChart,
                    includeAssessmentBarChart: response.data.includeAssessmentBarChart,
                    cgName: response.data.raters[2].raterName,
                    r1Name: response.data.raters[0].raterName,
                    r2Name: response.data.raters[1].raterName
                });
            }
            else {
                apiErrorPopup(apiResponseHandler(response));
            }
        })
        .catch(error => {
            // Major problem - should not happen.
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    render() {
        let subTitle = "Clear Child Reporting";
        let who = getCadeModeForName(authService.userType, this.props.cadeModeFor, this.state.r1Name, this.state.r2Name, this.state.cgName);
        this.assessmentReportKey = this.generateAssessmentReportKey();
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentHeader
                                cadeDomain="CADE Assessment"
                                subTitle={subTitle}
                            />
                        </Col>
                        <Col sm={8}>
                           
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentDoodle
                                domainImage="CadeAssessmentLG.png"
                                resClickHandler={null}
                                resources={null}
                                resKey={0}
                            />
                        </Col>
                        <Col sm={8}>
                            <CadeReportPerson
                                personFirstName={this.props.personFirstName}
                                personLastName={this.props.personLastName}
                                personBirthDate={this.props.personBirthDate}
                                assessmentDate={this.props.assessmentDate}
                                who={who}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <CadeReportAssessment
                                assessmentId={this.state.assessmentId}
                                cadeModeFor={this.props.cadeModeFor}
                                providerId={this.state.providerId}
                                isAssessmentComplete={this.state.isAssessmentComplete}
                                clinicianName={this.state.clinicianName}
                                clinicianDegrees={this.state.clinicianDegrees}
                                patientFirstName={this.props.personFirstName}
                                patientLastName={this.props.personLastName}
                                patientBirthDate={this.props.personBirthDate}
                                patientAgeWhenTested={this.state.patientAgeWhenTested}
                                testDate={this.state.testDate}
                                testsAdministered={this.state.testsAdministered}
                                reportDate={this.state.reportDate}
                                reasonForReferral={this.state.reasonForReferral}
                                testResults={this.state.testResults}
                                diagnosticImpressions={this.state.diagnosticImpressions}
                                summary={this.state.summary}
                                nextStep1={this.state.nextStep1}
                                nextStep2={this.state.nextStep2}
                                nextStep3={this.state.nextStep3}
                                nextStep4={this.state.nextStep4}
                                nextStep5={this.state.nextStep5}
                                readonly={this.state.readonly}
                                includeAssessmentRadarChart={this.state.includeAssessmentRadarChart}
                                includeAssessmentBarChart={this.state.includeAssessmentBarChart}
                                saveHandler={this.saveHandler}
                                accordionActiveKey={this.state.accordionActiveKey}
                                who={who}
                                key={this.assessmentReportKey + this.props.cadeModeFor}
                            />
                        </Col>
                    </Row>
                 
                </Container>

            </Fragment>
        );
    }
}

export default CadeReportAssessmentComponent;



// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeReportAssessmentComponent.js